<template>
  <div :class="['me-info-block flex items-start', `gap-${gap}`, classes,]">

    <ion-icon class="ion-icon" v-if="iconName" :name="iconName" :style='iconStyle'></ion-icon>

    <div class="flex-1 flex flex-col">
      <slot>
        <div class="flex-1 flex flex-wrap items-center justify-between gap-4">
          <div class="flex-0 flex flex-col">
            <h3
              v-if="title"
              class="font-bold mb-1"
            >
              {{ title }}
            </h3>

            <p
              v-if="text"
              class="text-small text-neutral-clear"
            >
              {{ text }}
            </p>
          </div>

          <p v-if="tag" class="tag tag--info normal-case">
            {{ tag }}
          </p>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'me-info-block',

  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: ''
    },
    gap: {
      type: String,
      default: '4'
    },
    iconSize: {
      type: Number,
      default: 48
    },
    iconName: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: "#000000"
    },
    orientation: {
      type: String,
      default: 'row',
      validator: (value) => ['row', 'column'].includes(value)
    },
    verticalAlignment: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'center'].includes(value)
    },
  },

  computed: {
    classes() {
      return {
        'me-info-block--column': this.orientation === 'column',
        'me-info-block--center': this.verticalAlignment === 'center'
      }
    },

    iconStyle() {
			return {
				width: `${this.iconSize}px`,
				height: `${this.iconSize}px`,
        color: this.iconColor
			};
		}
  }
}
</script>

<style lang="stylus" scoped>
.me-info-block
  text-align left

  &--column
    flex-direction column
    align-items center
    text-align center

    @media screen and (min-width 768px)
      align-items start
      text-align left

  &--center
    align-items center

</style>
